import React from 'react';
import { Button } from '@mantine/core';
import '../styles/components/button.css';

const ToggleButton = ({ 
  value, 
  onChange, 
  options, 
  className = ""
}) => {
  return (
<div className={`switch-container ${className}  gmarket-font`}>
      {options.map((option, index) => (
        <button
          key={option.value}
          className={`switch-button ${value === option.value ? 'active' : ''} ${index === 0 ? 'left' : 'right'}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton;